import { EmptyDetail } from '@/components/core-v2'

import { useFilteredGetByTenantAccountDashboardQuery } from '../../utils/useFilteredNotes'

export const NotesDetailEmptyState = () => {
  const { data } = useFilteredGetByTenantAccountDashboardQuery()
  if (!data) return null
  return <EmptyDetail amount={data.notes.length} word="note" />
}
